import { IOrganization } from '@/pages/Organizations/organizations.types.ts'
import SidePage from '@/shared/SidePage'
import SeparateLine from '@/shared/Forms/SeparateLine'
import useStateWithChange from '@/shared/hooks/useStateWithChange.ts'
import usersUtils from '@/pages/Users/users.utils.ts'
import FormField from '@/shared/Forms/FormField'
import TextInput from '@/shared/Inputs/TextInput'
import Button from '@/shared/Buttons/Button'
import useHttpLoader from '@/shared/hooks/useHttpLoader.ts'
import usersApi from '@/pages/Users/users.api.ts'
import usersEvents from '@/pages/Users/events/users.events.ts'
import confirmService from '@/services/ConfirmService/confirm.service.ts'
import UserFormFields from '@/pages/Users/components/UserFormFields'
import { useCallback } from 'react'

interface IProps {
  open: boolean
  onClose: () => void
  organizationId?: IOrganization['id']
}

const CreateUserSidePage = (props: IProps) => {
  const { wait, loading } = useHttpLoader()
  const [state, setState, handleChange] = useStateWithChange(
    usersUtils.generateCreateUserDTO({ organizationId: props.organizationId })
  )

  const handleCreate = () => {
    const password = usersUtils.randPassword()
    handleChange(password, 'password')

    wait(usersApi.create({ ...state, password }), (resp) => {
      if (resp.status === 'success') {
        usersEvents.created(resp.body)
        confirmService.requestConfirm({
          onConfirm: async () => props.onClose(),
          description: `Данные для входа созданного сотрудника:\n\nЛогин: ${resp.body.login}\nПароль: ${password}`,
          buttonType: 'primary',
          confirmText: 'Я скопировал(а) данные',
        })
      }
    })
  }

  const handleUserInfoChange = useCallback((val: any, name: string) => {
    setState((prev) => ({ ...prev, userInfo: { ...prev.userInfo, [name]: val } }))
  }, [])

  return (
    <SidePage onClose={props.onClose} open={props.open}>
      <div className="flex-lines gap16" style={{ height: '100%' }}>
        <h4 className="text-heading-4">Добавление сотрудника</h4>
        <SeparateLine />
        <UserFormFields user={state} onChange={handleChange} onUserInfoChange={handleUserInfoChange} />
        <SeparateLine />
        <h5 className="text-heading-5">Данные для входа</h5>
        <FormField label="Логин" required={true}>
          <TextInput value={state.login} name="login" onChange={handleChange} placeHolder="Введите логин" />
        </FormField>
        <FormField label="Пароль" required={true}>
          <p className="text-nm text-warning">
            Безопасный пароль будет автоматически сгенерирован после того, как вы нажмете кнопку "Добавить". Пароль
            будет доступен к просмотру в автоматически открывшемся модальном окне в течении 60 секунд.
          </p>
        </FormField>

        <div style={{ marginTop: 'auto' }}>
          <SeparateLine />
        </div>
        <div className="inline-flex-gap gap8">
          <Button size="default" type="primary" text="Добавить" onClick={handleCreate} loading={loading} />
          <Button size="default" type="default" text="Отменить" onClick={props.onClose} disabled={loading} />
        </div>
      </div>
    </SidePage>
  )
}

export default CreateUserSidePage
